@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$container-color: v.$palette-gray-900;
$border-color: v.$palette-gray-200;
$arrow-color: v.$palette-gray-400;
$arrow-active-color: v.$palette-accent;
$arrow-transition-duration: v.$transition-duration;

.container {
  border-bottom: 1px solid $border-color;
}

.containerList {
  overflow-x: hidden;
}

.toggler {
  @include t.text(14px, 18px, 600);
  color: $container-color;
  padding: 15px 0;
  cursor: pointer;
  user-select: none;
  display: flex;
}

.events {
  padding-left: 25px;
  padding-bottom: 15px;
}

.arrow {
  transform: rotate(90deg);
  margin-left: auto;
  transition: transform $arrow-transition-duration;

  path {
    stroke: $arrow-color;
    transition: stroke $arrow-transition-duration;
  }

  &.opened {
    transform: rotate(-90deg);

    path {
      stroke: $arrow-active-color;
    }
  }
}
